import { render, staticRenderFns } from "./privacy-policy-banner.vue?vue&type=template&id=45071e6c&scoped=true&"
import script from "./privacy-policy-banner.vue?vue&type=script&lang=js&"
export * from "./privacy-policy-banner.vue?vue&type=script&lang=js&"
import style0 from "./privacy-policy-banner.vue?vue&type=style&index=0&id=45071e6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45071e6c",
  null
  
)

export default component.exports